<template>
  <b-container class="grade-modal-form">

    <b-row align-v="end">
      <b-col cols="7"
             lg>
        <p class="p-form-label">Management rank</p>
        <b-form-select id="rank"
                       v-model="proposal.management_evaluation.rank"
                       :disabled="isDisabled"
                       :options="ranks"/>
      </b-col>
      <b-col class="pt-2" cols="5">
        <p class="p-form-label">Proposal status</p>
        <div>
          <traffic-lights-buttons v-model="proposal.management_evaluation.acceptance_mark"
                                  :disabled="isDisabled"
                                  :options="trafficLightsOptions"
                                  stacked/>
        </div>
      </b-col>
    </b-row>

    <b-row class="align-items-end">
      <b-col cols="6">
        <div class="shifts_container">
          <b-form-group :label="shift.text"
                        :label-class="shift.class"
                        class="shifts_item mt-2">
            <b-form-input v-model="proposal.management_evaluation[shift.model]"
                          :max="shift.max"
                          :min="shift.min"
                          :readonly="shift.readonly || isDisabled"
                          :step="shift.step"
                          type="number"
                          @paste.prevent/>
          </b-form-group>
        </div>
      </b-col>

      <b-col cols="6">
        <shifts-counter-reminder v-if="Object.keys(shiftsCounterData).length"
                                 :environment="specifiedEnvironment"
                                 :isManagementEvaluation="true"
                                 :shifts-counter-data="shiftsCounterData"/>
      </b-col>
    </b-row>

    <b-form-group label="Management comment for the User"
                  label-class="mt-2 font-weight-bold"
                  label-for="comment">
      <b-form-select :disabled="isDisabled"
                     :options="reviewComments"
                     class="col-md-6"
                     @input="useComment($event)"/>
      <b-form-textarea id="comment"
                       v-model="proposal.management_evaluation.comments"
                       :readonly="isDisabled"
                       max-rows="8"
                       rows="3"/>
    </b-form-group>

    <b-button v-if="isUserEditor"
              :disabled="isDisabled"
              class="ma-2 right"
              variant="info"
              @click="saveManagementEvaluation">
      SAVE
    </b-button>

  </b-container>
</template>

<script>
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import { comments } from '@/json/reviewComments';
  import ShiftsCounterReminder from '@/components/shifts-counter/ShiftsCounterReminder';
  import trafficLightsOptions from '@/json/trafficLightsAcceptanceMark';
  import TrafficLightsButtons from '@/components/traffic_lights_buttons';

  export default {
    components: {
      ShiftsCounterReminder,
      TrafficLightsButtons,
    },
    mixins: [infrastructureMixin],
    props: {
      value: {
        type: Object,
        default: () => {
        },
      },
      isUserEditor: {
        type: Boolean,
        required: true,
      },
      shiftsCounterData: {
        type: Object,
        default: () => {
        },
      },
    },
    data() {
      return {
        proposal: JSON.parse(JSON.stringify(this.value)),
        reviewComments: comments,
        ranks: ['A*', 'A', 'B', 'C', 'X'],
        specifiedEnvironment: '',
        shift: {},
        trafficLightsOptions,
      };
    },
    computed: {
      isDisabled() {
        if (!this.isUserEditor) return true;
        return this.proposal.management_evaluation.states?.name === 'submitted';
      },
    },
    watch: {
      value: {
        handler() {
          this.proposal = JSON.parse(JSON.stringify(this.value));
        },
        deep: true,
      },
    },
    async created() {
      const helpers = await this.getEvaluationDashboardProperties(this.infrastructure, 'ManagementEvaluation');
      this.shift = helpers.getSingleField('shift');
      this.specifiedEnvironment = (
        this.proposal.general.end_station || this.proposal.document_specification.type.toUpperCase()
      );
    },
    methods: {
      async saveManagementEvaluation() {
        try {
          const proposalId = this.getId(this.proposal);
          const response = await this.axios.post(
            `/documents/${proposalId}/management-evaluation/${this.infrastructure}`,
            this.proposal.management_evaluation,
          );
          // eslint-disable-next-line camelcase
          this.proposal.management_evaluation = response.data;
          this.$emit('input', this.proposal);
          this.$notify({ type: 'success', title: 'Saved successfully!' });
          this.closeModalEmit();
        } catch {
          this.$notify({ type: 'error', title: 'Changes and / or new status could not be saved' });
        }
      },
      useComment(option) {
        if (this.proposal.management_evaluation.comments === ''
          || this.proposal.management_evaluation.comments === undefined) {
          this.$set(this.proposal.management_evaluation, 'comments', option);
        } else {
          let finalComment = this.proposal.management_evaluation.comments;
          finalComment += `\n${option}`;
          this.proposal.management_evaluation.comments = finalComment;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .pull-right {
    float: right !important;
  }

  .grade-modal-form {
    padding: 0 0 1rem 0 !important;
    margin: 0 0 1rem 0 !important;
    max-width: none;
  }

  .shifts_container {
    margin-left: -15px;
    margin-right: -15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .shifts_item {
    width: 370px;
    margin: 15px
  }
</style>
